import "./App.css";

import idLocale from "./assets/locale/id.json";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { addLocale } from "primereact/api";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useContext } from "react";
import UiContext from "./store/ui-context";

import ErrorPage from "./pages/error/ErrorPage";
import LoginPage from "./pages/login/LoginPage";

//import admin page
import SignUpPage from "./pages/sign-up/SignUpPage";
import DefaultLayout from "./pages/default/DefaultLayout";
import HomePage from "./pages/default/home/HomePage";
import ProdukPage from "./pages/default/produk/ProdukPage";
import ListKategoriPage from "./pages/default/list-kategori/ListKategoriPage";
import KategoriPage from "./pages/default/kategori/KategoriPage";
import ListProdukPage from "./pages/default/list-produk/ListProdukPage";
import ProdukEditPage from "./pages/default/produk-edit/ProdukEditPage";
import ProtectedRoute from "./pages/protected/ProtectedRoute";

import { LoadScript } from "@react-google-maps/api";
import TokoPage from "./pages/default/toko/TokoPage";
import ListTokoPage from "./pages/default/list-toko/ListTokoPage";

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const libraries = ["places"];

// import reports

function App() {
  const uiContext = useContext(UiContext);

  const toastRef = useRef();

  useEffect(() => {
    uiContext.setToastRef(toastRef);
  }, [toastRef]);

  addLocale("id", idLocale.id);

  const getBaseName = () => {
    const reactAppPathV2 = process.env.REACT_APP_PATH + "/frontend/build_v2";
    if (window.location.pathname.includes(reactAppPathV2)) {
      return reactAppPathV2;
    } else {
      return "";
    }
  };

  const MyRouter = (
    <BrowserRouter basename={getBaseName()}>
      <Routes>
        <Route path="/login" element={<LoginPage />}></Route>
        <Route path="/sign-up" element={<SignUpPage />}></Route>
        <Route
          // index
          path="/"
          element={
            <ProtectedRoute>
              <DefaultLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<HomePage />}></Route>
          <Route path="produk">
            <Route path=":id" element={<ProdukPage />} />
          </Route>
          <Route path="edit-produk">
            <Route path=":id" element={<ProdukEditPage />} />
          </Route>
          <Route path="kategori">
            <Route path=":id" element={<KategoriPage />} />
          </Route>
          <Route path="toko">
            <Route path=":id" element={<TokoPage />} />
          </Route>
          <Route path="list-kategori" element={<ListKategoriPage />} />
          <Route path="list-produk" element={<ListProdukPage />} />
          <Route path="list-toko" element={<ListTokoPage />} />
          <Route path="master">
            {/* <Route path="tujuan" element={<TujuanMasterPage />} />
            <Route path="karyawan" element={<KaryawanMasterPage />} /> */}
          </Route>
        </Route>
        {/* <Route
          path="admin"
          element={
            <ProtectedRouteUser>
              <LayoutDashboardUserPage />
            </ProtectedRouteUser>
          }
        >
          <Route path="main" element={<UserHomePage />}></Route>
        </Route> */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );

  return (
    <>
      <Toast ref={toastRef} />
      {!toastRef.current && (
        <div className="col-center-center py-4">
          <h1> Initializing application ... </h1>{" "}
        </div>
      )}
      <LoadScript googleMapsApiKey={GOOGLE_API_KEY} libraries={libraries}>
        {toastRef.current && MyRouter}
      </LoadScript>
    </>
  );
}

export default App;
